import { render, staticRenderFns } from "./ReportIssue.vue?vue&type=template&id=f44b9792&scoped=true&"
import script from "./ReportIssue.vue?vue&type=script&lang=js&"
export * from "./ReportIssue.vue?vue&type=script&lang=js&"
import style0 from "./ReportIssue.vue?vue&type=style&index=0&id=f44b9792&prod&lang=scss&"
import style1 from "./ReportIssue.vue?vue&type=style&index=1&id=f44b9792&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44b9792",
  null
  
)

export default component.exports